<template>
	<div class="login">
		<v-card class="rounded-lg login-card" v-if="!forgotPassword">
			<div class="left">
				<v-spacer></v-spacer>
				<v-btn
					class="login-button pa-6 mb-4 rounded-lg"
					color="white"
					elevation="2"
					block
					:href="loginWithGoogle"
				>
					<img
						class="login-icon"
						src="../../assets/User/login/Google.svg"
						alt="google icon"
					/>
					<span class="google">Iniciar sesión con Google</span>
				</v-btn>

				<v-btn
					class="login-button pa-6 rounded-lg"
					color="#1877F2"
					elevation="2"
					block
					:href="loginWithFacebook"
				>
					<v-img
						class="login-icon"
						src="../../assets/User/login/facebook.png"
						alt="google icon"
					></v-img>
					<span>Iniciar sesión con Facebook</span>
				</v-btn>
				<v-spacer></v-spacer>
			</div>
			<div class="center py-4 hide-mobile">
				<v-divider vertical></v-divider>
			</div>
			<div class="right">
				<h2>Login</h2>
				<v-form v-model="valid">
					<!-- Email text field -->
					<v-text-field
						v-model="email"
						label="Email"
						required
						:rules="emailValidator"
						type="email"
					></v-text-field>

					<!-- Password text field -->
					<!-- Logic to show/hide password after label -->
					<v-text-field
						v-model="password"
						label="Contraseña"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="showPassword = !showPassword"
						:type="showPassword ? 'text' : 'password'"
						@keyup.enter="login"
						:rules="passwordValidator"
					>
					</v-text-field>

					<v-card-actions class="card-actions">
						<v-spacer></v-spacer>

						<!-- Login button -->
						<v-btn
							color="accent"
							@click="login"
							:disabled="!valid"
							class="rounded-lg"
							elevation="0"
							block
						>
							Login
						</v-btn>
					</v-card-actions>

					<!-- End of form -->
				</v-form>
				<v-row class="my-2">
					<v-spacer></v-spacer>
					<v-btn
						text
						class="rounded-lg"
						color="error"
						x-small
						@click="forgotPassword = true"
						>He olvidado mi contraseña</v-btn
					>
				</v-row>

				<div class="new-account">
					<p>
						¿Todavía no estás registrado?
						<a href="">
							<router-link :to="{ name: 'UserRegister' }">
								Crear cuenta
							</router-link>
						</a>
					</p>
				</div>
			</div>
		</v-card>

		<!-- Forgot password -->
		<v-card class="rounded-lg forgot-password-card login-card" v-else>
			<h2>He olvidado mi contraseña</h2>
			<p>
				Introduzca su correo a continuación. Recibirá un link en su
				bandeja de entrada.
			</p>
			<v-form v-model="resetPasswordValid">
				<!-- Email text field -->
				<v-text-field
					v-model="email"
					label="Email"
					required
					:rules="emailValidator"
					type="email"
					@keyup.enter.native="resetPassword"
				></v-text-field>

				<v-card-actions class="card-actions">
					<v-spacer></v-spacer>

					<!-- Login button -->
					<v-btn
						color="error"
						@click="forgotPassword = false"
						class="rounded-lg"
						text
					>
						Cancelar
					</v-btn>
					<!-- Login button -->
					<v-btn
						color="success"
						:disabled="!resetPasswordValid || loading"
						class="rounded-lg"
						:loading="loading"
						elevation="0"
						@click="resetPassword"
					>
						Resetear contraseña
					</v-btn>
				</v-card-actions>

				<!-- End of form -->
			</v-form>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";
import validator from "validator";

export default {
	name: "Login",
	data: () => ({
		loading: false,
		valid: false,
		email: "",
		password: "",
		showPassword: false,
		emailValidator: [(v) => validator.isEmail(v) || "Email inválido"],
		passwordValidator: [
			(v) => v !== "" || "La contraseña no debe estar vacía",
		],

		forgotPassword: false,
		resetPasswordValid: false,
	}),
	computed: {
		loginWithGoogle() {
			return `${process.env.VUE_APP_BACK_URL}/api/auth/google`;
		},
		loginWithFacebook() {
			return `${process.env.VUE_APP_BACK_URL}/api/auth/facebook`;
		},
	},
	methods: {
		/**
		 * Logs in the user
		 */
		async login() {
			try {
				//Wait for the response
				const response = await axios.post("/user/login", {
					email: this.email,
					password: this.password,
				});

				//And then save token to store and localstorage through the store action
				this.$store.dispatch("user/authSuccess", response.data.token);

				if (this.$route.params.redirect) {
					//Then redirect to the main user page
					this.$router.push({ path: this.$route.params.redirect });
				} else {
					//Then redirect to the main user page
					this.$router.push({ name: "UserMain" });
				}
			} catch (error) {
				this.showError(error);
			}
		},

		/**
		 * Reset the user password
		 */
		async resetPassword() {
			try {
				this.loading = true;
				await axios.post("/user/forgot-password", {
					email: this.email,
				});

				this.$emit("snackbar-event", {
					color: "success",
					text:
						"Se ha enviado un link a su correo para resetear la contraseña",
				});

				this.$router.push({ name: "UserMain" });
			} catch (error) {
				this.showError(error);
			}
		},

		showError(error) {
			let errorToDisplay;

			//If there is an array of errors
			if (error.response instanceof Array) {
				errorToDisplay = "";
				error.response.data.forEach((error) => {
					errorToDisplay += `${error}<br />`;
				});
				//If only one error
			} else if (error.response) {
				errorToDisplay = error.response.data;
				//Rest of the cases
			} else {
				//Show error snackbar
				errorToDisplay =
					"Ha ocurrido un error, vuelva a intentarlo más tarde";
			}

			this.$emit("snackbar-event", {
				color: "error",
				text: errorToDisplay,
			});
		},
	},
	async mounted() {
		if (this.$route.query.token) {
			//And then save token to store and localstorage through the store action
			await this.$store.dispatch(
				"user/authSuccess",
				this.$route.query.token
			);
			return this.$router.push({ name: "UserMain" });
		} else if (this.$route.query.error) {
			this.$emit("snackbar-event", {
				color: "error",
				text: this.$route.query.error,
			});
		}

		setTimeout(() => {
			if (this.$store.getters["user/getUser"].id) {
				console.log(this.$route.params);
				if (this.$route.params.redirect) {
					//Then redirect to the main user page
					this.$router.push({ path: this.$route.params.redirect });
				} else {
					//Then redirect to the main user page
					this.$router.push({ name: "UserMain" });
				}
			}
		}, 200);
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";
.login {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	padding: 2em 0.5em;

	@include desktop() {
		padding: 2em;
	}

	background-color: #f0f0f3;

	.login-card {
		background-color: #fafafa;
		display: flex;
		flex-direction: column-reverse;
		max-width: 500px;
		padding: 2em 0;
		height: fit-content;

		@include desktop() {
			justify-content: center;
			max-width: 800px;
			flex-direction: row;
		}

		.left,
		.right {
			padding: 0 2em;

			@include desktop() {
				&.left {
					height: 320px;
					display: flex;
					flex-direction: column;
				}

				&.right {
					padding-top: 0;
				}
			}
		}

		.card-actions {
			padding: 0;
		}

		.new-account {
			margin-top: 1em;

			a {
				color: $accent;
			}
		}
	}

	.forgot-password-card {
		padding: 2em !important;
		flex-direction: column !important;
	}
}

.login-button {
	display: flex;
	text-align: center;
	white-space: pre-wrap;
	max-height: 3em;

	.v-btn__content {
		width: 100%;
	}

	.login-icon {
		max-height: 24px;
		max-width: 24px;
	}
	span {
		flex: 1;
		color: #fff;
		padding-left: 1em;
		font-size: 1em;

		&.google {
			color: #808080;
		}
	}
}
</style>

<style lang="scss">
.login-button {
	.v-btn__content {
		width: 100% !important;
	}
}
</style>
